<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap>
      <!-- <v-flex md4 xs12>
        <v-subheader class="queryLabel">Res/Payt Transaction Date</v-subheader>
        <span class="queryValue">{{ formatDate(new Date()) }}</span>
      </v-flex> -->
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Insured Email</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.email }}</span>
      </v-flex>
      <v-flex xs12>
        <v-subheader class="queryLabel">Cause of Loss</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.cseLoss1 }}</span>
      </v-flex>
      <v-flex md8 xs12>
        <v-subheader class="queryLabel">Claim Event No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.clmEventDesc }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Cover Note No.</v-subheader>
        <span class="queryValue" v-if="claimHeaderForm.cnNo">{{ claimHeaderForm.cnNo }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Business Source</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.busSrcDesc }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Related Claim Ref No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.rlatClmRefNo }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Contract No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.contrtNo }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Insured Claim Ref No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.insdClmRefNo }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Agent</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.agentName }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Agent Suffix</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.agentAcctNoSfx }}</span>
      </v-flex>
      <v-flex md4 xs12 />
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Billing Account</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.acctNoName }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Account No. Suffix</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.acctNoSfx }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Department</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.dept }}</span>
      </v-flex>
      <v-flex md4 xs12 v-if="callerPage === 'claimStatus'">
        <v-subheader class="queryLabel">Insured</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.insdRefNo }} - {{ claimHeaderForm.insdName1 }}</span>
      </v-flex>
      <v-flex lg4 md4 xs12 v-else>
        <v-subheader class="queryLabel">Insured</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.insdRefNo }} - {{ claimHeaderForm.insdName1 }}</span>
        <v-tooltip top slot="append-outer">
          <template v-slot:activator="{ on }">
            <v-btn fab small icon color="grey lighten-4" v-on="on" @click="showInsuredDetails = true">
              <v-icon color="primary">mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <span>View Insured Details</span>
        </v-tooltip>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">I/C No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.icNo }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Business Registration No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.busRegNo }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Financial Interest</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.finInst }}</span>
      </v-flex>
      <v-flex lg4 md6 xs12>
        <v-subheader class="queryLabel">Policy Holder Client Group</v-subheader>
        <span>{{ phCltGrpValue(claimHeaderForm.phCltGrp) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Auto Recover Fax XOL</v-subheader>
        <span class="queryValue">{{ formatBool(claimHeaderForm.autoFacXolrcvy) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Executive in Charge</v-subheader>
        <span class="queryValue">{{ getExecIC }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Reference No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.refNo }}</span>
      </v-flex>
      <v-flex md8 xs12 v-if="claimHeaderForm.dept == 'M' || claimHeaderForm.dept == 'C'">
        <v-subheader class="queryLabel">Vehicle Reg No. / Vessel Name</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.vehVsl }}</span>
      </v-flex>
      <!--v-flex md4 xs12>
        <v-subheader class="queryLabel">Is Policy Holder GST Registered?</v-subheader>
        <span class="queryValue">{{ formatBool(claimHeaderForm.isPhGstreg) }}</span>
      </v-flex>
      <v-flex md4 xs12 v-if="claimHeaderForm.isPhGstreg">
        <v-subheader class="queryLabel">GST Reg No.</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.gstRegNo }}</span>
      </v-flex>
      <v-flex md4 xs12 v-if="claimHeaderForm.isPhGstreg">
        <v-subheader class="queryLabel">GST Reg Date</v-subheader>
        <span class="queryValue">{{ formatDate(claimHeaderForm.gstRegDate) }}</span>
      </v-flex-->
    </v-layout>
    <v-divider></v-divider>
    <v-layout row wrap>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Created By</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.createdBy }} on {{ formatDate(claimHeaderForm.createdDate) }}</span>
      </v-flex>
      <v-flex md4 xs12>
        <v-subheader class="queryLabel">Last Updated By</v-subheader>
        <span class="queryValue">{{ claimHeaderForm.modifiedBy }} on {{ formatDate(claimHeaderForm.modifiedDate) }}</span>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showInsuredDetails" width="1280px">
      <query-insured
        :boolRefresh="showInsuredDetails"
        @close="showInsuredDetails = false"
        :insuredRefNo="this.claimHeaderForm.insdRefNo"
      ></query-insured>
    </v-dialog>
  </v-container>
</template>

<script>
import { CLAIMS_LIFECYCLE, CLAIMS_CLAIMDETAIL_CLAIMANT } from '@/store/types'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import { formatDisplayDate, formatDisplayDateTime4 } from '@/utils/date'
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import { clmClsTypes, phCltGrps } from '@/const/claims'
import { expandURI } from '@/utils/ajax'
import QueryInsured from '@/components/core/claimManagement/queryClaim/QueryInsured'

export default {
  data() {
    return {
      claimHeaderForm: {},
      interlist: [],
      validInsd: false,
      showInsuredDetails: false
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    resCurrList() {
      return this.$store.state.claims.claimParams.resCurrList
    },
    clmClsTypes() {
      return clmClsTypes
    },
    getGrossReserveOS() {
      return this.commonInfo.totResLoc - this.commonInfo.planPaytLoc - this.commonInfo.paidAmtLoc
    },
    getExecIC() {
      for (let inter of this.interlist) {
        if (inter.value === this.commonInfo.acctNo1) {
          return inter.secondaryValue
        }
      }
      return ''
    }
  },
  methods: {
    async doInit() {
      this.claimHeaderForm = clone(this.commonInfo)
      await Promise.all([this.$store.dispatch('claimEntryInit')])
      this.fetchInterList()
      this.checkInsdRefNo()
    },
    phCltGrpValue(key) {
      if (key && phCltGrps[key]) {
        return key + ' - ' + phCltGrps[key] || '-'
      }
      return '-'
    },
    getInsuredName() {
      var result = ''
      if (this.claimHeaderForm.insdRefNo) {
        result += this.claimHeaderForm.insdRefNo
      }
      if (this.claimHeaderForm.insdName1) {
        result += ' - ' + this.claimHeaderForm.insdName1
      }
      return result
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime4(dateTime) {
      return formatDisplayDateTime4(dateTime)
    },
    formatBool(bool) {
      if (bool) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    async doProceed() {
      await this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMANT, this.claimHeaderForm)
      this.$store.commit(CLAIMS_LIFECYCLE, 3)
      this.$router.push({ name: 'qClaimClaimant' })
    },
    async fetchInterList() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.getIntermediaryList
      if (apiUrl) {
        try {
          this.interlist = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'interlist', result.data.dataList)
          }
        } catch (err) {
          this.interlist = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async checkInsdRefNo() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.checkInsdRefNo
      if (apiUrl) {
        try {
          const expand = {
            insdRefNo: this.commonInfo.insdRefNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.validInsd = data
          }
          return true
        } catch (err) {
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    to2Decimal(value) {
      if (value) {
        const intVal = parseInt(value, 10)
        // CBO: Added regex for the thousand separator.
        return intVal.toFixed(2).toString()
      } else {
        if (value === '0' || value === 0) {
          // CBO: Expecting 0 will be treated as null in this case.
          return '0.00'
        }
      }
      return value
    },
    toThousandSeparator(value) {
      if (value) {
        return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
    },
    getInsDet() {
      if (this.validInsd === true) {
        this.$router.push({ name: 'queryInsured', params: { insdRefNo: this.claimHeaderForm.insdRefNo } })
      } else {
        this.$toast.error('No Insured Details record for this Insured.')
        return false
      }
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    QueryInsured
  },
  mixins: [MessageMixin, ClaimCommonMixin],
  props: {
    callerPage: String
  }
}
</script>

<style lang="scss">
.linkstyle {
  font-size: 12px;
  font-weight: 400;
  text-decoration: underline;
  color: #009688;
  cursor: pointer;
}
</style>
